export default "__VITE_ASSET__DbM3HjNA__"